import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { ITicketProps } from '../../../../../../types/Ticket/ITicket';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import { SetSelectedActions } from '../../../../../../slices/SelectedActionsSlice';
import { useCurrentUserContext } from '../../../../../../context/UserContext';

const MoveButton: React.FC<ITicketProps> = (ticket) => {
    const selectedActions = useReduxSelector(state => state.selectedActionsStore.selectedActions);
    const dispatch = useReduxDispatch();
    const navigate = useNavigate();
    const { profile: userProfile } = useCurrentUserContext();
    const thisTicketActionsSelected = selectedActions?.filter(a => a.ticketId === ticket.ID);
    const moveClicked = (e) => {
        console.log('moveClicked', thisTicketActionsSelected)
        if (!thisTicketActionsSelected || thisTicketActionsSelected?.length === 0) {
            if (thisTicketActionsSelected?.length === 0) { window.alert(`Select 1 or more ${userProfile?.Phrases.Action}s to Move`) }
            //Show the option to selected actions
            dispatch(SetSelectedActions([]));
            return;
        }

        navigate('move')
    }

    return (<>
        <Button disabled={ticket.Is_Loading} className='related-button' onClick={moveClicked} title={`Move Actions to another ${userProfile?.Phrases.CallPhrase}`} imageUrl='./images/Toolbar/merge.png'
            size='large' ></Button>
        {/* thisTicketActionsSelected={JSON.stringify(thisTicketActionsSelected)} */}
    </>
    );
};

export default MoveButton;